import React, { useMemo } from "react";
import "./menu-providers.scss";
import { useTranslation } from "react-i18next";
import IconPik from "../../../mui/JSXIcons/IconPik";
import { useDispatch, useSelector } from "react-redux";
import ShowContainer from "../../../mui/ShowContainer";
import { Link, useParams } from "react-router-dom";
import { setOpenMenu, sortProviderClick } from "../../../../store/siteSlice";
import useGetLinkCallback from "../../../../hooks/other/useGetLinkCallback";
import { getProviderNameBySubId } from "../../../../utils/utils";
import IconSortAb from "../../../mui/JSXIcons/IconSortAb";
import IconSort09 from "../../../mui/JSXIcons/IconSort09";
import { useAppSelector } from "../../../../store/index.ts";
import { ENUM_SORT_TYPE } from "../../../../store/enums";
import IconSortBa from "../../../mui/JSXIcons/IconSortBa";
import IconSort90 from "../../../mui/JSXIcons/IconSort90.jsx";

export default function MenuProviders() {
  const { t } = useTranslation();
  const { subId } = useParams();
  const dispatch = useDispatch();
  const providers = useSelector((state) => state.games.providers);
  const getLink = useGetLinkCallback();
  const { sort, isReverse } = useAppSelector((state) => state.site.providerSort);

  const sortProviders = useMemo(() => {
    const newProviders = [...providers];

    switch (sort) {
      case ENUM_SORT_TYPE.name:
        newProviders.sort((l, r) => l.cusName?.localeCompare(r.cusName));
        break;
      case ENUM_SORT_TYPE.countGames:
        newProviders.sort((l, r) => r.gameCount - l.gameCount);
        break;
      default:
        break;
    }

    return isReverse ? newProviders.reverse() : newProviders;
  }, [providers, sort, isReverse]);

  const onSortClick = () => dispatch(sortProviderClick());

  const SORT_ICONS = {
    [ENUM_SORT_TYPE.name]: { asc: IconSortAb, desc: IconSortBa },
    [ENUM_SORT_TYPE.countGames]: { asc: IconSort09, desc: IconSort90 }
  };

  const SortIcon = SORT_ICONS[sort][isReverse ? "desc" : "asc"];

  return (
    <ShowContainer condition={providers?.length}>
      <div className="menu__providers">
        <div className="menu__providers__title">
          <h2>
            <IconPik />
            {t("Casino games")}
          </h2>
          <button aria-label={t("Sort")} onClick={onSortClick}>
            <SortIcon />
          </button>
        </div>
        <div className="menu__providers__list">
          {sortProviders.map((provider, indx) => {
            const id = subId?.split("_").at(-1);
            let isActive = undefined;

            if (+id) {
              isActive = +id === +provider.id;
            } else {
              isActive = getProviderNameBySubId(subId) === provider.cusName;
            }
            const activeClass = isActive ? "active" : "";

            return (
              <Link
                to={getLink(provider.url)}
                onClick={() => dispatch(setOpenMenu(false))}
                className={`menu__providers__list__item ${activeClass}`}
                key={`${provider.id}_${indx}`}>
                <img
                  className="menu__providers__list__item__img"
                  src={provider.logo}
                  alt={t("Provider logo") + provider.displayName}
                />
                <span className="menu__providers__list__item__title">{provider.displayName}</span>
                <div className="menu__providers__list__item__count">
                  <span>{provider.gameCount}</span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </ShowContainer>
  );
}
